<template>
	<div class="case">
		<!-- header -->
		<!-- <div class="case.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="case.block">
			<intellectual-navigation  :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="case.bread" data-aos="fade-left">
			<Bread :currentPage="{name:'成功案例',path:'/Case'}"/>
		</div>
		<div class="case.container">
			<div class="case.item" data-aos="fade-right">
				<img src="../assets/trademarks/trade-head.jpg" alt="">
			</div>
			<div class="case.item">
				<top-ranking :topRanks="topRanks" v-show="pageParams.pageMNo == 1 || topLists.length > 15"></top-ranking>
				<top-lists :topLists="topLists" :pageParams="pageParams" @updateLists="updateLists"></top-lists>
			</div>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'
	import TopRanking from '../components/top-ranking.vue'
	import TopLists from '../components/top-lists.vue'
	
	
	export default{
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,
			TopRanking,
			TopLists
			
		
		},
		data(){
			return{
				isTrademark:false,
				pageParams:{
					totalMCount: 0,
					pageMNo: 1,
				},
				topRanks:[],
				topLists:[]
			}
		},
		methods:{
			toggleTrademarks(val){
				this.isTrademark = val
			},
			initCaswData(page){
				page = page ? page : 1;
				this.http.get(`IPR_Success?page=${page}&check_time=2`).then(res => {
					//console.log(res.data.data)
					if(page == 1){
						this.topLists = res.data.data.slice(3)
						this.topRanks = res.data.data.slice(0,3)
					}else{
						if(res.data.data.length > 15){
							this.topLists = res.data.data.slice(3)
							this.topRanks = res.data.data.slice(0,3)
						}else{
							this.topLists = res.data.data
						}
						
					}
					this.pageParams.totalMCount = res.data.total
					
				})
			},
			updateLists(val){
				this.initCaswData(val)
			},
			
		},
		mounted(){
			this.initCaswData()
		}
	}
</script>

<style lang="scss">
	@include component(case){
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}
		@include part(bread){
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}
		@include part(container){
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			
		}
		@include part(item){
			width: 1200px;
			margin: 0 auto;
			padding-top: 18px;
			padding-bottom: 18px;
		}


	}
</style>
